// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3M8n0","footerContent":"styles_footerContent__2DtSY","socialIcon":"styles_socialIcon__3NLBi"};